// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Container,
//   Card,
//   CardContent,
//   Avatar,
//   CircularProgress,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate } from "react-router-dom";
// import { BASE_URL } from "../../Api/ApiUrls";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import DeleteIcon from "@mui/icons-material/Delete";
// import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
// import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
// import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';


// const WantedProperties = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);
//   const [responses, setResponses] = useState({});
//   const [openResponses, setOpenResponses] = useState({});
//   const [deletingId, setDeletingId] = useState(null);


//   const [data, setData] = useState([]); 
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
// const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
// const [showDeleteFailure, setShowDeleteFailure] = useState(false);
// const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
// const [requestToDelete, setRequestToDelete] = useState(null);
// const [alertMessage, setAlertMessage] = useState("");

//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     accent: "#A52A2A",
//     background: "#b9a990",
//     cardBackground: "#FFFFFF",
//     textDark: "#1a1a1a",
//     textLight: "#FFFFFF",
//     textMuted: "#666666"
//   };

// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       console.log("🚀 Fetching data...");
//       console.log("👤 User ID:", userId);

//       const [reqRes, respRes] = await Promise.all([
//         axios.get(`${BASE_URL}/property-request/?user_id=${userId}`),
//         axios.get(`${BASE_URL}/response-property-request/`),
//       ]);

//       console.log("📥 Property Requests API Response:", reqRes.data);
//       console.log("📥 Response Property Requests API Response:", respRes.data);

//       // ✅ Handle paginated response - no need to filter by user_id anymore
//       const userProperties = (
//         reqRes.data.results ||
//         reqRes.data.data ||
//         reqRes.data ||
//         []
//       ).reverse();

//       console.log("✅ User Properties:", userProperties);

//       // group responses by req_id
//       const groupedResponses = respRes.data.reduce((acc, item) => {
//         console.log("📌 Processing Response:", item.id, "req_id:", item.req_id);

//         if (!acc[item.req_id]) {
//           acc[item.req_id] = [];
//         }

//         acc[item.req_id].push(item);

//         return acc;
//       }, {});

//       console.log("✅ Grouped Responses:", groupedResponses);

//       setData(userProperties);
//       setResponses(groupedResponses);

//       console.log("🎯 Final Data Set:", userProperties);
//       console.log("🎯 Final Responses Set:", groupedResponses);

//       setLoading(false);
//     } catch (err) {
//       console.error("❌ Error Fetching Data:", err);

//       if (err.response) {
//         console.error("📛 Error Response:", err.response.data);
//         console.error("📛 Status:", err.response.status);
//       }

//       setError("Failed to load data");
//       setLoading(false);
//     }
//   };

//   if (userId) {
//     console.log("✅ User authenticated, fetching data...");
//     fetchData();
//   } else {
//     console.warn("⚠️ User not authenticated. userId:", userId);
//     setError("User not authenticated");
//     setLoading(false);
//   }
// }, [userId]);

//  const formatBudget = (min, max) => {
//   if (!min && !max) return "Not specified";
  
//   const formatNumber = (num) => {
//     const numValue = parseFloat(num) || 0;
    
//     if (numValue >= 10000000) { // 1 Crore+
//       return `₹${(numValue / 10000000).toFixed(1)} Cr`;
//     } else if (numValue >= 100000) { // 1 Lakh+
//       return `₹${(numValue / 100000).toFixed(1)} L`;
//     } else if (numValue >= 1000) { // 1 Thousand+
//       return `₹${(numValue / 1000).toFixed(1)} K`;
//     } else {
//       return `₹${numValue}`;
//     }
//   };
  
//   const minNum = parseFloat(min) || 0;
//   const maxNum = parseFloat(max) || 0;
  
//   if (minNum === maxNum) return formatNumber(minNum);
  
//   const minFormatted = formatNumber(minNum);
//   const maxFormatted = formatNumber(maxNum);
  
//   // If both have same suffix, show only once
//   const getSuffix = (str) => {
//     if (str.includes('Cr')) return 'Cr';
//     if (str.includes('L')) return 'L';
//     if (str.includes('K')) return 'K';
//     return '';
//   };
  
//   const minSuffix = getSuffix(minFormatted);
//   const maxSuffix = getSuffix(maxFormatted);
  
//   if (minSuffix && minSuffix === maxSuffix) {
//     const minValue = minFormatted.replace(` ${minSuffix}`, '').replace('₹', '');
//     const maxValue = maxFormatted.replace(` ${maxSuffix}`, '').replace('₹', '');
//     return `₹${minValue}-${maxValue} ${minSuffix}`;
//   }
  
//   return `${minFormatted} - ${maxFormatted}`;
// };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffMs = now - date;
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
//     if (diffDays === 0) return "Today";
//     if (diffDays === 1) return "Yesterday";
//     if (diffDays < 7) return `${diffDays} days ago`;
//     if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
//   };

//   const formatDimensions = (property) => {
//     if (property.length > 0 && property.width > 0) {
//       const area = property.length * property.width;
//       const units = property.units || 'ft';
//       return `${property.length}*${property.width} (${area}) ${units === 'm' ? 'sq m' : 'sq ft'}`;
//     }
//     return null;
//   };

//   const toggleResponse = (reqId) => {
//     setOpenResponses(prev => ({
//       ...prev,
//       [reqId]: !prev[reqId]
//     }));
//   };

//   const handleViewAllResponses = (property) => {
//     navigate("/all-responses", {
//       state: {
//         responses: responses[property.req_id] || [],
//         property
//       }
//     });
//   };

// const handleDeleteRequest = (e, request) => {
//   e.stopPropagation();
//   setRequestToDelete(request);
//   setShowDeleteConfirm(true);
// };
// const performDelete = async () => {
//   if (!requestToDelete) return;
  
//   setDeletingId(requestToDelete.req_id);
  
//   try {
//     await axios.delete(`${BASE_URL}/property-request/${requestToDelete.req_id}/`);
    
//     // Remove the deleted request from state
//     setData(prevData => prevData.filter(item => item.req_id !== requestToDelete.req_id));
    
//     setAlertMessage("Property request deleted successfully!");
//     setShowDeleteSuccess(true);
    
//   } catch (err) {
//     console.error("Error deleting property request:", err);
//     setAlertMessage("Failed to delete property request. Please try again.");
//     setShowDeleteFailure(true);
//   } finally {
//     setDeletingId(null);
//     setRequestToDelete(null);
//   }
// };

//   // ==================== BLACK SPINNER WHILE LOADING ====================
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: 'rgb(239, 231, 221)',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
//         <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
//           Loading Wanted properties...
//         </Typography>
//       </Box>
//     );
//   }
//   if (error) {
//     return (
//       <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
//         <Typography variant="h6" color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
//       {/* ===================== TOP BAR ===================== */}
//       <AppBar position="fixed" sx={{ backgroundColor: colors.primary, color: colors.textLight ,zIndex: 1200}}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2 }}>Wanted Properties</Typography>
//         </Toolbar>
//       </AppBar>

//       {/* ===================== CONTENT ===================== */}
//       <Box sx={{ p: 1.5, flex: 1,  pt: { xs: '80px', sm: '100px' },pb: 10, backgroundColor: colors.background }}>
//         {data.length === 0 ? (
//           <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
//             No property requests found
//           </Typography>
//         ) : (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
//             {data.map((property) => (
//               <Card 
//                 key={property.req_id}
//                 sx={{ 
//                   borderRadius: 2, 
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
//                   border: `1px solid #e0e0e0`, 
//                   overflow: 'hidden',
//                   cursor: 'pointer',
//                   '&:hover': {
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                     transform: 'translateY(-2px)',
//                     transition: 'all 0.2s ease'
//                   }
//                 }}
//                 onClick={(e) => {
//                   // Only navigate if the click is not on interactive elements
//                   if (!e.target.closest('.no-navigate') && 
//                       !e.target.closest('button') && 
//                       !e.target.closest('a')) {
//                     navigate(`/wanted-prop-details/${property.req_id}`);
//                   }
//                 }}
//               >
//                 <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
//                   {/* Header section - Clickable area */}
//                   <Box 
//                     sx={{ 
//                       p: 1, 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       justifyContent: 'space-between', 
//                       backgroundColor: colors.primary,
//                       cursor: 'pointer'
//                     }}
//                   >
//                     {/* Purchase Section */}
//                     <Box sx={{ 
//                       backgroundColor: "#b9a990", 
//                       color: colors.primary,
//                       px: 1.5,
//                       py: 0.5,
//                       borderRadius: 3,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }}>
//                       <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1 }}>
//                         {property.looking_for ? property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1) : "Property"}
//                       </Typography>
//                     </Box>
                    
//                     {/* Budget Section */}
//                     <Box sx={{ 
//                       backgroundColor: colors.cardBackground, 
//                       color: colors.primary,
//                       px: 1.5,
//                       py: 0.5,
//                       borderRadius: 3,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }}>
//                       <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1, fontSize: '0.9rem' }}>
//                         Budget: {formatBudget(property.min_budget, property.max_budget)}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   <Box sx={{ p: 1.5 }}>
//                     <Box sx={{ display: 'grid', gap: 0.75 }}>
//                       {/* Type */}
//                       <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//                         <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
//                           <strong>Property Type:</strong>
//                         </Typography>
//                         <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
//                           {property.property_type || "Not specified"}
//                         </Typography>
//                       </Box>

//                       {/* Location */}
//                       <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//                         <Typography
//                           variant="body2"
//                           color={colors.textDark}
//                           sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}
//                         >
//                           <strong>Location:</strong>
//                         </Typography>
//                         <Typography variant="body2">
//                           {property.pro_loc?.length > 0 ? (
//                             property.pro_loc.map(loc => (
//                               <div key={loc.loc_id}>• {loc.location}</div>
//                             ))
//                           ) : (
//                             "Not specified"
//                           )}
//                         </Typography>
//                       </Box>

//                       {/* Dimensions when available */}
//                       {formatDimensions(property) && (
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
//                             <strong>Length*Width:</strong>
//                           </Typography>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
//                             {formatDimensions(property)}
//                           </Typography>
//                         </Box>
//                       )}
                      
//                       {/* Fallback to area if dimensions not available */}
//                       {(property.area > 0 && !formatDimensions(property)) && (
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
//                             <strong>Length*Width:</strong>
//                           </Typography>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
//                             {`${property.area} ${property.units || 'sq ft'}`}
//                           </Typography>
//                         </Box>
//                       )}
                      
//                       {/* Fallback to acres if neither dimensions nor area available */}
//                       {((property.min_acres > 0 || property.max_acres > 0) && !formatDimensions(property) && property.area <= 0) && (
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
//                             <strong>Length*Width:</strong>
//                           </Typography>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
//                             {`${property.min_acres}${property.max_acres > property.min_acres ? `-${property.max_acres}` : ''} acres`}
//                           </Typography>
//                         </Box>
//                       )}
                      
//                       {/* Ratio */}
//                       {property.ratio && (
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 80, flexShrink: 0 }}>
//                             <strong>Ratio:</strong>
//                           </Typography>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
//                             {property.ratio}
//                           </Typography>
//                         </Box>
//                       )}

//                       {/* User and Date - REMOVED the negative margin */}
//                       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
//                         <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
//                           <Avatar sx={{ width: 16, height: 16, fontSize: '0.5rem', mr: 0.5 }}>
//                             👤
//                           </Avatar>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 75, flexShrink: 0, mr: 0.5 }}>
//                             <strong>CUST {property.user_id}</strong>
//                           </Typography>
//                           <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
//                             {formatDate(property.created_at)}
//                           </Typography>
//                         </Box>

//                       <IconButton
//   onClick={(e) => handleDeleteRequest(e, property)}
//   disabled={deletingId === property.req_id}
//   className="no-navigate"
//   sx={{
//     width: 32,
//     height: 32,
//     zIndex: 10,
//     position: 'relative',
//     "&:hover": {
//       backgroundColor: "#ffebee",
//     }
//   }}
// >
//   {deletingId === property.req_id ? (
//     <CircularProgress size={20} sx={{ color: "#ff4444" }} />
//   ) : (
//     <DeleteIcon sx={{ color: "#ff4444", fontSize: 20 }} />
//   )}
// </IconButton>
//                       </Box>
//                     </Box>

//                     {/* ================= RESPONSES ================= */}
//                     {responses[property.req_id]?.length > 0 && (
//                       <Box 
//                         className="no-navigate"
//                         sx={{ mt: 1.5, pt: 1, borderTop: '1px dashed #ccc' }}
//                       >
//                         {/* Show / Hide button */}
//                         <Typography
//                           onClick={() => toggleResponse(property.req_id)}
//                           sx={{
//                             fontSize: '0.75rem',
//                             fontWeight: 600,
//                             mb: 0.5,
//                             cursor: 'pointer',
//                             color: '#a89478ff'
//                           }}
//                         >
//                           {openResponses[property.req_id] ? 'Hide Responses' : 'Show Responses'} ({responses[property.req_id].length})
//                         </Typography>

//                         {/* Expanded content */}
//                         {openResponses[property.req_id] && (
//                           <>
//                             {/* Show only FIRST response */}
//                             <Box
//                               sx={{
//                                 backgroundColor: '#f7f4ef',
//                                 borderRadius: 1,
//                                 p: 0.75,
//                                 mb: 0.5
//                               }}
//                             >
//                               <Typography sx={{ fontSize: '0.75rem' }}>
//                                 {responses[property.req_id][0].comment}
//                               </Typography>

//                               {responses[property.req_id][0].proerty_link && (
//                                 <Typography
//                                   component="a"
//                                   href={responses[property.req_id][0].proerty_link}
//                                   onClick={(e) => e.stopPropagation()}
//                                   sx={{
//                                     fontSize: '0.7rem',
//                                     color: '#1a1a1a',
//                                     display: 'block',
//                                     mt: 0.3,
//                                     textDecoration: 'underline',
//                                     cursor: 'pointer'
//                                   }}
//                                 >
//                                   View Property
//                                 </Typography>
//                               )}

//                               <Typography sx={{ fontSize: '0.65rem', opacity: 0.6, mt: 0.3 }}>
//                                 {formatDate(responses[property.req_id][0].created_at)}
//                               </Typography>
//                             </Box>

//                             {/* +N more */}
//                             {responses[property.req_id].length > 1 && (
//                               <Typography
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewAllResponses(property);
//                                 }}
//                                 sx={{
//                                   fontSize: '0.7rem',
//                                   fontWeight: 600,
//                                   cursor: 'pointer',
//                                   color: '#8B7355'
//                                 }}
//                               >
//                                 +{responses[property.req_id].length - 1} more
//                               </Typography>
//                             )}
//                           </>
//                         )}
//                       </Box>
//                     )}
//                   </Box>
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         )}
//       </Box>


//       {/* Delete Success */}
//       {showDeleteSuccess && (
//         <DeleteSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
      
//       {/* Delete Failure */}
//       {showDeleteFailure && (
//         <DeleteFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
// {showDeleteConfirm && requestToDelete && (
//   <DeleteConfirmAlert
//     message={`Are you sure you want to delete this property request? This action cannot be undone.`}
//     onOk={() => {
//       setShowDeleteConfirm(false);
//       performDelete();
//     }}
//     onCancel={() => {
//       setShowDeleteConfirm(false);
//       setRequestToDelete(null);
//     }}
//   />
// )}
//       {/* ===================== BOTTOM NAV ===================== */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
//         <CustomBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// export default WantedProperties;


//======================================================



import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Card,
  CardContent,
  Avatar,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Api/ApiUrls";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';

const WantedProperties = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const [responses, setResponses] = useState({});
  const [openResponses, setOpenResponses] = useState({});
  const [deletingId, setDeletingId] = useState(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [requestToDelete, setRequestToDelete] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");

  const colors = {
    primary: "#1a1a1a",
    gold: "#D9A441",
    goldSoft: "rgba(217,164,65,0.10)",
    background: "rgb(239, 231, 221)",
    cardBackground: "#FFFFFF",
    line: "#E8E5E0",
    textDark: "#1a1a1a",
    textLight: "#FFFFFF",
    textMuted: "#8a8a8a",
    danger: "#E74C3C",
  };

  /* ==================== DATA ==================== */

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [reqRes, respRes] = await Promise.all([
          axios.get(`${BASE_URL}/property-request/?user_id=${userId}`),
          axios.get(`${BASE_URL}/response-property-request/`),
        ]);

        const userProperties = (
          reqRes.data.results ||
          reqRes.data.data ||
          reqRes.data ||
          []
        ).reverse();

        const groupedResponses = respRes.data.reduce((acc, item) => {
          if (!acc[item.req_id]) acc[item.req_id] = [];
          acc[item.req_id].push(item);
          return acc;
        }, {});

        setData(userProperties);
        setResponses(groupedResponses);
        setLoading(false);
      } catch (err) {
        console.error("Error Fetching Data:", err);
        setError("Failed to load data");
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    } else {
      setError("User not authenticated");
      setLoading(false);
    }
  }, [userId]);

  /* ==================== HELPERS ==================== */

  const formatBudget = (min, max) => {
    if (!min && !max) return "Not specified";

    const formatNumber = (num) => {
      const numValue = parseFloat(num) || 0;
      if (numValue >= 10000000) return `₹${(numValue / 10000000).toFixed(1)} Cr`;
      if (numValue >= 100000) return `₹${(numValue / 100000).toFixed(1)} L`;
      if (numValue >= 1000) return `₹${(numValue / 1000).toFixed(1)} K`;
      return `₹${numValue}`;
    };

    const minNum = parseFloat(min) || 0;
    const maxNum = parseFloat(max) || 0;

    if (minNum === maxNum) return formatNumber(minNum);

    const minFormatted = formatNumber(minNum);
    const maxFormatted = formatNumber(maxNum);

    const getSuffix = (str) => {
      if (str.includes("Cr")) return "Cr";
      if (str.includes("L")) return "L";
      if (str.includes("K")) return "K";
      return "";
    };

    const minSuffix = getSuffix(minFormatted);
    const maxSuffix = getSuffix(maxFormatted);

    if (minSuffix && minSuffix === maxSuffix) {
      const minValue = minFormatted.replace(` ${minSuffix}`, "").replace("₹", "");
      const maxValue = maxFormatted.replace(` ${maxSuffix}`, "").replace("₹", "");
      return `₹${minValue}-${maxValue} ${minSuffix}`;
    }

    return `${minFormatted} - ${maxFormatted}`;
  };

 const formatDate = (dateString) => {
  if (!dateString) return "Not specified";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Not specified";

  const now = new Date();
  const diffMs = now - date;

  // future timestamp safeguard
  if (diffMs < 0) return "Just now";

  const diffSecs  = Math.floor(diffMs / 1000);
  const diffMins  = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays  = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffSecs < 60)   return "Just now";
  if (diffMins < 60)   return `${diffMins}m ago`;
  if (diffHours < 24)  return `${diffHours}h ago`;
  if (diffDays === 1)  return "Yesterday";
  if (diffDays < 7)    return `${diffDays}d ago`;
  if (diffDays < 30)   return `${Math.floor(diffDays / 7)}w ago`;

  return date.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
};

  const formatDimensions = (property) => {
    if (property.length > 0 && property.width > 0) {
      const area = property.length * property.width;
      const units = property.units || "ft";
      return `${property.length}×${property.width} (${area}) ${units === "m" ? "sq m" : "sq ft"}`;
    }
    return null;
  };

  const getSizeValue = (property) => {
    const dims = formatDimensions(property);
    if (dims) return dims;
    if (property.area > 0) return `${property.area} ${property.units || "sq ft"}`;
    if (property.min_acres > 0 || property.max_acres > 0) {
      return `${property.min_acres}${
        property.max_acres > property.min_acres ? `-${property.max_acres}` : ""
      } acres`;
    }
    return "Not specified";
  };

  const getLocationText = (property) => {
    if (property.pro_loc?.length > 0) {
      return property.pro_loc.map((loc) => loc.location).join(", ");
    }
    return "Not specified";
  };

  /* ==================== HANDLERS ==================== */

  const toggleResponse = (reqId) => {
    setOpenResponses((prev) => ({ ...prev, [reqId]: !prev[reqId] }));
  };

  const handleViewAllResponses = (property) => {
    navigate("/all-responses", {
      state: { responses: responses[property.req_id] || [], property },
    });
  };

  const handleDeleteRequest = (e, request) => {
    e.stopPropagation();
    setRequestToDelete(request);
    setShowDeleteConfirm(true);
  };

  const performDelete = async () => {
    if (!requestToDelete) return;
    setDeletingId(requestToDelete.req_id);
    try {
      await axios.delete(`${BASE_URL}/property-request/${requestToDelete.req_id}/`);
      setData((prevData) => prevData.filter((item) => item.req_id !== requestToDelete.req_id));
      setAlertMessage("Property request deleted successfully!");
      setShowDeleteSuccess(true);
    } catch (err) {
      console.error("Error deleting property request:", err);
      setAlertMessage("Failed to delete property request. Please try again.");
      setShowDeleteFailure(true);
    } finally {
      setDeletingId(null);
      setRequestToDelete(null);
    }
  };

  /* ==================== SPEC CELL ==================== */

  const SpecCell = ({ label, value, index, total }) => (
    <Box
      sx={{
        px: 1.2,
        py: 1,
        position: "relative",
        minWidth: 0,
        ...(index % 2 === 0 &&
          index !== total - 1 && {
            "&::after": {
              content: '""',
              position: "absolute",
              right: 0,
              top: "18%",
              height: "64%",
              width: "1px",
              backgroundColor: colors.line,
            },
          }),
        ...(index < total - (total % 2 === 0 ? 2 : 1) && {
          borderBottom: `1px solid ${colors.line}`,
        }),
      }}
    >
      <Typography
        sx={{
          fontSize: "0.62rem",
          color: colors.textMuted,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          fontWeight: 600,
          mb: 0.2,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: "0.78rem",
          fontWeight: 700,
          color: colors.textDark,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {value || "Not specified"}
      </Typography>
    </Box>
  );

  /* ==================== CARD ==================== */

  const renderCard = (property) => {
    const specs = [
      { label: "Property Type", value: property.property_type },
      { label: "Size", value: getSizeValue(property) },
      ...(property.ratio ? [{ label: "Ratio", value: property.ratio }] : []),
      { label: "Request ID", value: property.req_id ? `#${property.req_id}` : null },
    ];
    const propResponses = responses[property.req_id] || [];

    return (
      <Card
        key={property.req_id}
        onClick={(e) => {
          if (
            !e.target.closest(".no-navigate") &&
            !e.target.closest("button") &&
            !e.target.closest("a")
          ) {
            navigate(`/wanted-prop-details/${property.req_id}`);
          }
        }}
        sx={{
          borderRadius: "14px",
          backgroundColor: colors.cardBackground,
          border: `1px solid ${colors.line}`,
          borderLeft: `4px solid ${colors.gold}`,
          boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
          overflow: "hidden",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            boxShadow: "0 6px 18px rgba(0,0,0,0.13)",
            transform: "translateY(-2px)",
          },
        }}
      >
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          {/* ---------- Header ---------- */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1.4,
              pt: 1.3,
              pb: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.6,
                backgroundColor: colors.primary,
                color: colors.gold,
                px: 1.2,
                py: 0.5,
                borderRadius: "8px",
              }}
            >
              <SearchIcon sx={{ fontSize: 14 }} />
              <Typography
                sx={{ fontSize: "0.66rem", fontWeight: 700, letterSpacing: "0.6px", lineHeight: 1 }}
              >
                {property.looking_for
                  ? property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1)
                  : "PROPERTY"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
              <AccessTimeIcon sx={{ fontSize: 13, color: colors.textMuted }} />
              <Typography sx={{ fontSize: "0.68rem", color: colors.textMuted }}>
                {formatDate(property.created_at)}
              </Typography>
            </Box>
          </Box>

          {/* ---------- Budget band ---------- */}
          <Box
            sx={{
              mx: 1.4,
              px: 1.4,
              py: 1,
              borderRadius: "10px",
              backgroundColor: colors.goldSoft,
              border: `1px dashed ${colors.gold}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: "0.62rem",
                fontWeight: 700,
                color: "#a9762a",
                textTransform: "uppercase",
                letterSpacing: "0.7px",
              }}
            >
              Budget Range
            </Typography>
            <Typography
              sx={{ fontSize: "1.02rem", fontWeight: 800, color: colors.gold, whiteSpace: "nowrap" }}
            >
              {formatBudget(property.min_budget, property.max_budget)}
            </Typography>
          </Box>

          {/* ---------- Location(s) ---------- */}
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.6, px: 1.4, pt: 1.2, pb: 1 }}>
            <LocationOnIcon sx={{ fontSize: 16, color: colors.textMuted, mt: "1px", flexShrink: 0 }} />
            <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: colors.textDark, lineHeight: 1.3 }}>
              {getLocationText(property)}
            </Typography>
          </Box>

          {/* ---------- Spec grid ---------- */}
          <Box
            sx={{
              mx: 1.4,
              mb: 1.2,
              border: `1px solid ${colors.line}`,
              borderRadius: "10px",
              overflow: "hidden",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              backgroundColor: "#FCFBF9",
            }}
          >
            {specs.map((spec, index) => (
              <SpecCell key={spec.label} label={spec.label} value={spec.value} index={index} total={specs.length} />
            ))}
          </Box>

          {/* ---------- Footer: user + delete ---------- */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1.4,
              py: 1,
              borderTop: `1px solid ${colors.line}`,
              backgroundColor: "#FAF8F5",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  bgcolor: colors.primary,
                  color: colors.gold,
                }}
              >
                {String(property.user_id || "U").slice(-2)}
              </Avatar>
              <Box>
                <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: colors.textDark, lineHeight: 1.1 }}>
                  CUST {property.user_id}
                </Typography>
                <Typography sx={{ fontSize: "0.62rem", color: colors.textMuted }}>Requested by you</Typography>
              </Box>
            </Box>

            <IconButton
              onClick={(e) => handleDeleteRequest(e, property)}
              disabled={deletingId === property.req_id}
              className="no-navigate"
              sx={{
                width: 30,
                height: 30,
                border: "1px solid rgba(231,76,60,0.35)",
                borderRadius: "8px",
                "&:hover": { backgroundColor: "rgba(231,76,60,0.08)" },
              }}
            >
              {deletingId === property.req_id ? (
                <CircularProgress size={16} sx={{ color: colors.danger }} />
              ) : (
                <DeleteIcon sx={{ color: colors.danger, fontSize: 17 }} />
              )}
            </IconButton>
          </Box>

          {/* ---------- Responses ---------- */}
          {propResponses.length > 0 && (
            <Box className="no-navigate" sx={{ borderTop: `1px solid ${colors.line}`, px: 1.4, py: 1 }}>
              <Box
                onClick={() => toggleResponse(property.req_id)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                  <ChatBubbleOutlineIcon sx={{ fontSize: 15, color: colors.gold }} />
                  <Typography sx={{ fontSize: "0.75rem", fontWeight: 700, color: colors.textDark }}>
                    {propResponses.length} {propResponses.length === 1 ? "Response" : "Responses"}
                  </Typography>
                </Box>
                {openResponses[property.req_id] ? (
                  <ExpandLessIcon sx={{ fontSize: 18, color: colors.textMuted }} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 18, color: colors.textMuted }} />
                )}
              </Box>

              {openResponses[property.req_id] && (
                <>
                  <Box sx={{ backgroundColor: colors.goldSoft, borderRadius: "8px", p: 1, mt: 0.8 }}>
                    <Typography sx={{ fontSize: "0.75rem", color: colors.textDark }}>
                      {propResponses[0].comment}
                    </Typography>

                    {propResponses[0].proerty_link && (
                      <Typography
                        component="a"
                        href={propResponses[0].proerty_link}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                          fontSize: "0.7rem",
                          color: colors.primary,
                          fontWeight: 600,
                          display: "block",
                          mt: 0.4,
                          textDecoration: "underline",
                        }}
                      >
                        View Property
                      </Typography>
                    )}

                    <Typography sx={{ fontSize: "0.65rem", color: colors.textMuted, mt: 0.4 }}>
                      {formatDate(propResponses[0].created_at)}
                    </Typography>
                  </Box>

                  {propResponses.length > 1 && (
                    <Typography
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewAllResponses(property);
                      }}
                      sx={{
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        color: colors.gold,
                        cursor: "pointer",
                        mt: 0.8,
                      }}
                    >
                      +{propResponses.length - 1} more →
                    </Typography>
                  )}
                </>
              )}
            </Box>
          )}
        </CardContent>
      </Card>
    );
  };

  /* ==================== RENDER ==================== */

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: colors.background,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: "#000000" }} />
        <Typography variant="h7" sx={{ color: "#000000", fontWeight: 600 }}>
          Loading Wanted properties...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: colors.background,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
      <AppBar position="fixed" sx={{ backgroundColor: colors.primary, color: colors.textLight, zIndex: 1200 }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, fontSize: "1.05rem" }}>
            Wanted Properties
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 1.5, flex: 1, pt: { xs: "80px", sm: "100px" }, pb: 10, backgroundColor: colors.background }}>
        {data.length === 0 ? (
          <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
            No property requests found
          </Typography>
        ) : (
          <>
            <Typography
              sx={{
                fontSize: "0.72rem",
                fontWeight: 700,
                color: "#6b6257",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
                mb: 1,
                px: 0.5,
              }}
            >
              {data.length} {data.length === 1 ? "Request" : "Requests"}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {data.map((property) => renderCard(property))}
            </Box>
          </>
        )}
      </Box>

      {/* Delete Success */}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage("");
          }}
        />
      )}

      {/* Delete Failure */}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage("");
          }}
        />
      )}

      {showDeleteConfirm && requestToDelete && (
        <DeleteConfirmAlert
          message="Are you sure you want to delete this property request? This action cannot be undone."
          onOk={() => {
            setShowDeleteConfirm(false);
            performDelete();
          }}
          onCancel={() => {
            setShowDeleteConfirm(false);
            setRequestToDelete(null);
          }}
        />
      )}

      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default WantedProperties;